import React, { Component } from 'react';
import { WIBThemeProvider } from '@web-ib/components/ui';
import { getEnvFromHostname, getEnvString } from '@web-ib/components/support';
import { Button, Footer, TitleBar } from '@bbnpm/bb-ui-framework';
import styles from './login.module.css';

const HOST = `${window.location.protocol}//${window.location.host}`;

const login = (): void => {
    window.open(`${HOST}/login`, '_self');
};

const DEFAULT_PAGE_TITLE = 'IB Anywhere';

class Login extends Component<{}> {
    componentDidMount(): void {
        const title = document.getElementById('app_title');

        const envString = getEnvString(
            getEnvFromHostname(window.location.hostname),
        );

        if (title) {
            if (envString) {
                title.textContent = `${DEFAULT_PAGE_TITLE} (${envString})`;
            } else {
                title.textContent = DEFAULT_PAGE_TITLE;
            }
        }
    }

    public render() {
        const envString = getEnvString(
            getEnvFromHostname(window.location.hostname),
        );

        const envIndicator = envString ? (
            <span style={{ color: '#00FFFF' }}>{envString}</span>
        ) : (
            ''
        );

        return (
            <WIBThemeProvider>
                <div className={styles.container}>
                    <div className={styles.titlebar_container}>
                        <TitleBar
                            productName={DEFAULT_PAGE_TITLE}
                            envIndicator={envIndicator}
                            skipToId="main-content"
                        />
                    </div>
                    <div className={styles.body_container} id="main-content">
                        <h1>
                            <span className={styles.orange}>
                                Instant Bloomberg
                            </span>
                        </h1>
                        <p>
                            Welcome to IB Anywhere - Instant Bloomberg, anywhere
                            with a browser
                        </p>
                        <Button
                            kind="primary"
                            className={styles.button}
                            onClick={login}
                            autoFocus
                            tabIndex={0}
                        >
                            Login
                        </Button>
                    </div>
                    <Footer copyright={new Date().getFullYear()} />
                </div>
            </WIBThemeProvider>
        );
    }
}

export default Login;
